import { h } from "preact";
import {useEffect} from "preact/hooks";

function TermListComponent(props) {
    const translations = {
        no_items: window.Drupal.t('No items')
    }

    const ItemsList = () => {
        // show loader white terms are fetching
        if (!props.fetchedData) {
            return (
                <div className="loading-dots display center-grid-element">
                    <div className="loading-dots--dot"></div>
                    <div className="loading-dots--dot"></div>
                    <div className="loading-dots--dot"></div>
                </div>
            );
        }

        if (
            props.filter !== undefined
            && props.filter !== ''
            && props.terms !== undefined
            && props.terms[props.filter] !== undefined
        ) {
            // sort items by title (ABC..)
            return props.terms[props.filter].sort(function(a, b) {
                    let titleA = a.title.toUpperCase(); // ignore upper and lowercase
                    let titleB = b.title.toUpperCase(); // ignore upper and lowercase
                    if (titleA < titleB) {
                        return -1;
                    }
                    if (titleA > titleB) {
                        return 1;
                    }

                    return 0;
                }).map(item => {
                let rawHTML = {__html: item.body};

                return (
                   <div className="glossary-term__item">
                       <div className="glossary-term__title">{item.title}</div>
                       <div className="glossary-term__desc" dangerouslySetInnerHTML={rawHTML}/>
                   </div>
                );
            })
        }

        return <div>{translations.no_items}</div>;
    }

    return (
        <div className="glossary-term__list">
            <ItemsList/>
        </div>
    );
}

export default TermListComponent;